import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { logout } from "../../redux/slices/userSlice";
import { get_initial_courses } from "../../redux/slices/coursesSlice";

import { Axios } from "../../api";
import {
  error_alert,
  removeUserOnboardingData,
  success_alert,
} from "../../utils";

const AcademyContainer = ({ path }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);

  const handleLogout = async () => {
    try {
      const result = await Axios.get("users/logout");
      dispatch(logout());
      removeUserOnboardingData();
      dispatch(get_initial_courses());
      if (path.includes("/academy/courses/course")) {
        // history.push(`/academy/courses`);
        history.push(`/academy/mastering-trans-axillary`);
      } else {
        history.push(`${path}`);
      }
      success_alert(
        result?.data?.description
          ? result.data.description
          : "Logout successfully!"
      );
    } catch (e) {
      if (e.response) {
        console.log(e.response.data);
        error_alert(JSON.stringify(e.response.data.description));
      } else {
        error_alert("Network Error");
      }
    }
  };

  return (
    <div className="hidden lg:flex justify-end items-center pb-4 -mb-8 -2xl:mb-4 relative z-50 bg-white">
      <div className="px-5 xl:px-8 pt-2 flex flex-col items-end relative">
        <div className="text-xs xl:text-sm 2xl:text-base text-blue-primary font-medium uppercase">
          {user ? `${user?.first_name} ${user?.last_name}` : "-"}
        </div>
        <div className="text-xs xl:text-sm 2xl:text-base text-red-primary font-medium">
          {user ? user?.email : "-"}
        </div>
      </div>

      {/* Logout button */}
      <div className="px-5 xl:px-8 pt-6 border-l-2 border-gray-light flex items-end relative">
        <div
          onClick={() => handleLogout()}
          className="text-xs xl:text-sm 2xl:text-base text-red-primary font-medium uppercase cursor-pointer"
        >
          Logout
        </div>
      </div>
    </div>
  );
};

export default AcademyContainer;
